<formio-filtered-form-select-dialog
    *ngIf="displaySelectFormDialog"
    [returnUrl]="returnUrl"
    [visible]="displaySelectFormDialog"
    [categories]="[moduleName]"
    [currentEpisode]="currentEpisode"
    [isHomePage]="true"
    (onSelect)="formSelected($event)"
    (onCancel)="displaySelectFormDialog = false">
</formio-filtered-form-select-dialog>

<formio-select-episode-dialog
    *ngIf="displaySelectEpisodeDialog"
    [episodeRequired]="episodeRequired"
    [patientId]="patientService.currentPatientId"
    [restoreSelectControlState]="restoreSelectControlState"
    [restoreDuplicateCheakState]="restoreDuplicateCheakState"
    [episode]="currentEpisode"
    (onSkip)="onSkipOkEpisodeSelectDialog($event)"
    (onCancel)="onCancelEpisodeSelectDialog()">
</formio-select-episode-dialog>

<multi-user-form-create-instance-dialog
    *ngIf="displayMufCreateInstanceDialog"
    [episodeId]="this.currentEpisode ? this.currentEpisode.id : null"
    [patientId]="patientService.currentPatientId"
    [multiUserFormDef]="currentMUFDef"
    (onCancel)="onCancelCreateInstanceDialog()"
    (onCreate)="onCreateInstanceDialog($event)">
</multi-user-form-create-instance-dialog>

<formio-select-patient-dialog
    *ngIf="displaySelectPatientDialog"
    (onOk)="onOkSelectPatientDialog($event)"
    (onCancel)="displaySelectPatientDialog = false">
</formio-select-patient-dialog>

<formio-form-request-dialog
    *ngIf="displayNewFormRequestDialog"
    [patientId]="patientService.currentPatientId"
    [formRevisionId]="currentFormDef.activeRevision.id"
    [episodeId]="currentEpisode?.id"
    (onCancel)="onCancelFormRequestDialog()"
    (onCreate)="onCreateFormRequestDialog()">
</formio-form-request-dialog>
